module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-b"
  }, [_vm._v("ACKNOWLEDGMENTS")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("My thanks to "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("People")]), _vm._v(" managing editor Landon Y. Jones and chief of reporters Nancy P. Williamson for their patience and support. Also, I owe a debt of gratitude to my editor Charles Spicer and his assistant, Liz Weinstock, St. Martin’s’ managing editor John Rounds, my agent Jane Dystel, and "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("People")]), _vm._v(" writer Joe Treen.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a25ac4ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 69
// module chunks = 0